<div
    *ngIf="showInternalVideo"
    class="w-full relative overflow-hidden"
    [ngStyle]="{
        'aspect-ratio': mobileMode ? component.mobileAspectRatio ?? '16/9' : component.aspectRatio ?? '16/9'
    }">
    <div class="w-full h-14 flex gap-4 justify-end absolute p-4 top-0 right-0 bg-gradient-to-b from-black/40 z-20" *ngIf="!loading && (playing || paused) && (subtitles.length || component.playlist && playlist.length)">
        <button
            role="button"
            type="button"
            aria-label="Toggle subtitles"
            class="w-8 h-8 cursor-pointer text-white"
            *ngIf="subtitles.length"
            (click)="toggleSubtitles()"
            aria-label="Toggle Subtitles">
            <svg height="32" viewBox="-21 -91 682.66669 682" width="32" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><path d="m565 495.667969h-490c-41.359375 0-75-33.644531-75-75v-350c0-41.359375 33.640625-75 75-75h490c41.359375 0 75 33.640625 75 75v350c0 41.355469-33.640625 75-75 75zm-490-450c-13.785156 0-25 11.214843-25 25v350c0 13.78125 11.214844 25 25 25h490c13.785156 0 25-11.21875 25-25v-350c0-13.785157-11.214844-25-25-25zm170 237.5v2.5c0 26.191406-21.308594 47.5-47.5 47.5s-47.5-21.308594-47.5-47.5v-80c0-26.191407 21.308594-47.5 47.5-47.5s47.5 21.308593 47.5 47.5v2.5h50v-2.5c0-53.761719-43.734375-97.5-97.5-97.5s-97.5 43.738281-97.5 97.5v80c0 53.757812 43.734375 97.5 97.5 97.5s97.5-43.742188 97.5-97.5v-2.5zm245 0v2.5c0 26.191406-21.308594 47.5-47.5 47.5s-47.5-21.308594-47.5-47.5v-80c0-26.191407 21.308594-47.5 47.5-47.5s47.5 21.308593 47.5 47.5v2.5h50v-2.5c0-53.761719-43.734375-97.5-97.5-97.5s-97.5 43.738281-97.5 97.5v80c0 53.757812 43.734375 97.5 97.5 97.5s97.5-43.742188 97.5-97.5v-2.5zm0 0"></path></svg>
        </button>
        <button
            role="button"
            class="w-8 h-8 cursor-pointer text-white"
            *ngIf="component.playlist && playlist.length"
            (click)="togglePlaylist()"
            aria-label="Show Playlist"
            matTooltip="Show Playlist">
            <svg height="32" viewBox="0 0 512 512" width="32" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><path d="m280.593 449.83a16 16 0 0 1 -16 16h-248.593a16 16 0 0 1 0-32h248.593a16 16 0 0 1 16 16zm-16-151.538h-248.593a16 16 0 0 0 0 32h248.593a16 16 0 0 0 0-32zm-248.593-239.076h480a16 16 0 0 0 0-32h-480a16 16 0 0 0 0 32zm496 322.845a16 16 0 0 1 -7.773 13.723l-144.673 86.724a16 16 0 0 1 -24.226-13.724v-173.447a16 16 0 0 1 24.226-13.724l144.672 86.724a16 16 0 0 1 7.774 13.724zm-47.12 0-97.552-58.478v116.956zm31.12-219.307h-480a16 16 0 0 0 0 32h480a16 16 0 0 0 0-32z"></path></svg>
        </button>
    </div>

    <div class="absolute inset-0 w-full h-full p-8 flex flex-col gap-4 justify-center items-center text-white text-lg bg-transparent hover:bg-black/20 z-10 group" *ngIf="!component.autoplay && !loading && !playing && !paused" role="dialog">
        <button name="play" type="button" role="button" aria-label="Play Video" class="flex items-center rounded-full !bg-black/20 cursor-pointer w-24 h-24 group-hover::text-white/70" type="button" (click)="togglePlay()">
            <span class="mat-icon text-[96px]">play_circle</span>
        </button>
        <span *ngIf="component.caption" class="hidden max-w-xl text-center invisible group-hover:visible text-lg text-white">{{component.caption}}</span>
    </div>

    <div *ngIf="loading" class="absolute inset-0 w-full h-full bg-white z-30">
        <div class="w-full h-full bg-gray-400 flex flex-col gap-4 justify-center items-center">
            <div role="status">
                <svg aria-hidden="true" class="w-24 h-24 mr-2 text-gray-200 animate-spin fill-indigo-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                </svg>
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>

    <div class="absolute bg-white p-4 top-0 md:w-3/4 w-full h-full z-30 transition-all ease-in-out" [ngClass]="{
        'right-0': showPlaylist,
        'md:right-[-75%] right-[100%]': !showPlaylist,
    }">
        <div class="absolute right-0 top-0 pr-4 pt-4">
            <button
                type="button"
                role="button"
                aria-label="Toggle Playlist"
                (click)="togglePlaylist()"
                class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                <span class="sr-only">Close</span>
                <svg
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
        <ul role="list" class="divide-y divide-gray-100">
            <li class="flex gap-x-4 py-5 cursor-pointer" (click)="playPlaylistVideo(originVideo)">
              <img class="h-12 flex-none rounded-sm bg-gray-50" [src]="originVideo?.thumbnail" [alt]="originVideo?.name">
              <div class="min-w-0">
                <p class="text-sm font-semibold leading-6 text-gray-900">{{originVideo?.name}} <span *ngIf="videoData?._id === originVideo?._id">(Currently playing)</span></p>
                <p class="mt-1 truncate text-xs leading-5 text-gray-500">Duration: {{originVideo?.dynamoData?.srcMediainfo?.container?.duration | date:'hh:mm'}}</p>
              </div>
            </li>
            <li *ngFor="let v of playlist" class="flex gap-x-4 py-5 cursor-pointer" (click)="playPlaylistVideo(v)">
                <img class="h-12 flex-none rounded-sm bg-gray-50" [src]="v.thumbnail" [alt]="v.name">
                <div class="min-w-0">
                  <p class="text-sm font-semibold leading-6 text-gray-900">{{v?.name}} <span *ngIf="videoData?._id === v?._id">(Currently playing)</span></p>
                  <p class="mt-1 truncate text-xs leading-5 text-gray-500">Duration: {{v.dynamoData?.srcMediainfo?.container?.duration | date:'hh:mm'}}</p>
                </div>
              </li>
        </ul>
    </div>

    <video class="w-full h-full object-cover" #videoElement crossorigin loop playsinline></video>
</div>

<div *ngIf="showLoomVideo" #loom></div>

<div *ngIf="showYouTubeVideo" #youtube class="w-full relative overflow-hidden" [ngStyle]="{
    'aspect-ratio': mobileMode ? component.mobileAspectRatio ?? '16/9' : component.aspectRatio ?? '16/9'
}"></div>
